<template>
  <section class="news-section">
    <!-- 标题 + 分类 -->
    <div class="news-header">
      <h2 class="news-title">新闻资讯</h2>
      <div class="news-tabs">
        <span
          v-for="tab in tabs"
          :key="tab"
          :class="['tab', { active: currentTab === tab }]"
          @click="switchTab(tab)"
        >
          {{ tab }}
        </span>
      </div>
    </div>
    <!-- 新闻列表：一页 = 一行 = 3 条 -->
    <div class="news-list">
      <div
        class="news-card"
        v-for="item in newsList"
        :key="item.id"
        @click="goDetail(item.id)"
      >
        <div class="image-wrapper">
          <img
            :src="item.cover || ''"
            :alt="item.title"
          />
        </div>
        <div class="news-content">
          <h3 class="news-card-title">
            {{ item.title }}
          </h3>
          <p class="news-desc">
            {{ stripHtml(item.content).slice(0, 60) }}...
          </p>
          <span class="news-date">
            {{ formatDate(item.created_at) }}
          </span>
        </div>
      </div>
    </div>
    <!-- 分页（居中显示） -->
    <div class="pagination">
      <button
        :disabled="page === 1"
        @click="changePage(page - 1)"
      >
        上一页
      </button>
      <span class="page-info">
        第 {{ page }} / {{ totalPage }} 页
      </span>
      <button
        :disabled="page >= totalPage"
        @click="changePage(page + 1)"
      >
        下一页
      </button>
    </div>
  </section>
</template>
<script>
import axios from 'axios'
export default {
  name: 'NewsSection',
  data() {
    return {
      // 分类
      tabs: ['通知公告', '综合新闻', '合作交流', '科普动态', '党群文化'],
      currentTab: '通知公告',
      // 新闻数据
      newsList: [],
      // 分页
      page: 1,
      pageSize: 3, // ⭐ 一页 3 条 = 一行
      total: 0,
      // ⭐ 【新增】定义分类与后台 type 的映射关系表
      // 这样后续如果增加新的分类，只需要在这里加一行配置即可，不用写一堆 if-else
      categoryTypeMap: {
        '通知公告': 'notice',
        '综合新闻': 'news',
        '合作交流': 'news',
        '科普动态': 'news',
        '党群文化': 'news'
      }
    }
  },
  computed: {
    totalPage() {
      return Math.ceil(this.total / this.pageSize)
    }
  },
  mounted() {
    this.fetchNews()
  },
  methods: {
    /** 获取新闻（分页） */
    async fetchNews() {
      try {
        // ⭐ 【核心修改】根据当前选中的分类，从映射表中动态获取对应的 type
        // 如果映射表中找不到当前分类，则默认回退为 'news'，防止报错
        const currentType = this.categoryTypeMap[this.currentTab] || 'news'
        const res = await axios.get('/news', {
          params: {
            status: 'published',
            category: this.currentTab,
            page: this.page,
            type: currentType, // ⭐ 【核心修改】将原来写死的 'news' 替换为动态计算的 currentType
            limit: this.pageSize
          }
        })
        // ⚠️ 后端需返回 { list, total }
        this.newsList = res.data.list || []
        this.total = res.data.total || 0
      } catch (err) {
        console.error('获取新闻失败', err)
      }
    },
    /** 切换分类 */
    switchTab(tab) {
      this.currentTab = tab
      this.page = 1
      this.fetchNews()
    },
    /** 翻页 */
    changePage(p) {
      if (p < 1 || p > this.totalPage) return
      this.page = p
      this.fetchNews()
    },
    /** 跳转详情页 */
    goDetail(id) {
      this.$router.push(`/news/${id}`)
    },
    /** 时间格式化 */
    formatDate(time) {
      if (!time) return ''
      const d = new Date(time)
      const y = d.getFullYear()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${y}-${m}-${day}`
    },
    /** 去除 HTML / Markdown 标签 */
    stripHtml(html) {
      if (!html) return ''
      // 去掉标签
      let text = html.replace(/<[^>]+>/g, '')
      // 利用浏览器解析 HTML 实体
      const parser = new DOMParser()
      text = parser.parseFromString(text, 'text/html').body.textContent || ''
      // 压缩空格
      return text.replace(/\s+/g, ' ').trim()
    }
  }
}
</script>
<style scoped src="@/assets/styles/newssections.css"></style>